import '@unocss/reset/tailwind-compat.css';
import { setupLayouts } from 'virtual:generated-layouts';
import { routes } from 'vue-router/auto-routes';
import { createApp } from 'vue';
import { api, CirqllSDKPlugin } from '@cirqll/sdk';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import eventBus from './event_bus';
import { withModalBack } from './utils/modal_back';

// Your custom styles here
import './styles/main.css';
// Windicss utilities should be the last style import
import 'virtual:uno.css';

import './native_overrides';

const app = createApp(App);

// Setup up pages with layouts
const router = createRouter({ history: withModalBack(createWebHistory()), routes: setupLayouts([...routes]) });
app.use(router);
app.use(CirqllSDKPlugin, { queryClientConfig: { defaultOptions: { queries: { refetchOnWindowFocus: false } } } });
app.config.errorHandler = (err) => {
    // oxlint-disable-next-line no-console
    console.error(err);
    return false;
};

// Install all modules under `modules/`
const modules = Object.values(import.meta.glob('./modules/*.ts', { eager: true, import: 'install' }));
for (const module of Object.values(modules)) {
    if (typeof module === 'function') {
        module({ app, router, routes });
    }
}

app.provide('eventBus', eventBus);
app.provide('api', api);
app.mount('#app');

window.addEventListener('vite:preloadError', () => {
    window.location.reload();
});
